import { useEffect, useState } from "react";
import { Header, HeaderSmall, Padding } from "../text_display/main_content_text_styling";
import { TableRenderer } from "../widgets/table";
import { db_get_all_users_and_roles } from "../../nonComponentFunctions/api/user_requests";
import { useAuth } from "../../authentication/auth_provider";

export function AdminGetAllUsers({ jwt, requestor_mail }) {
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const { mail, token } = useAuth();

  const set_user_infos = async () => {
    const response = await db_get_all_users_and_roles(
      (requestor_mail !== undefined && requestor_mail) || mail,
      (jwt !== undefined && jwt) || token
    )
    setHeaders(["Mail", "Firstname", "Lastname", "Role"]);
    setRows(
      response.request_details.user_infos.map((info) => {
        return [
          info["mail"],
          info["firstname"],
          info["lastname"],
          info["role"]
        ]
      })
    )
  }

  useEffect(() => {
    set_user_infos();
  }, [])
  return (
    <Padding>
      <Header text={"Admin Section"} />
      <HeaderSmall text={"List Users"} />
      <TableRenderer
        headers={headers}
        rows={rows}
      />
    </Padding>
  )
}
